export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5501.571ea254.jpg";